
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import { deserialise } from 'kitsu-core'
import { getRequest } from '@/plugins/api-axios'
import { getRequestHeaders, getURL, projectBaseUrl } from '@/utils/axios'
import { initProject, initProjectClose } from '@/utils/project'
import lodash from 'lodash'
import AddButton from '@/_components/button/add/add.vue'

const AdminProjects = Vue.extend({
    mixins: [AppMixin],
    components: { AddButton },
    props: {
        company: {
            type: Object,
            required: true,
        },
        searchTerm: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            infiniteId: 0,
            offset: 0,
            limit: 20,
            projects: [] as Array<any>,
            routes: {
                observation: 'observations',
                contractor: 'project-contractors',
                hse: 'hse-all',
                psi: 'psi',
                personnel: 'personnel',
            },
        }
    },

    methods: {
        initiateProjects() {
            this.offset = 0
            this.infiniteId = Date.now()
            this.projects = []
        },

        async loadProjects($state: any) {
            let { data } = await getRequest(
                getURL({
                    path: `projects`,
                    base: projectBaseUrl,
                    params: {
                        ...(this.searchTerm &&
                            this.searchTerm.length > 1 && {
                                'filter[searchTerm]': this.searchTerm,
                            }),
                        'filter[owner]': this.company.id,
                        'page[limit]': this.limit,
                        'page[offset]': this.offset,
                        include: 'owner.id,modules',
                    },
                }),
                getRequestHeaders('GET')
            )

            let res = deserialise(data).data

            this.projects = [...this.projects, ...res]
            if (res.length == this.limit) {
                $state.loaded()
                this.offset += this.limit
            } else {
                $state.complete()
            }
        },

        hasNotClosedModules(project: any) {
            return (
                project.modules.data &&
                project.modules.data.findIndex((module) => {
                    return module.status !== 'deleted'
                }) > -1
            )
        },

        isDeleted(project: any) {
            return !this.hasNotClosedModules(project) && project.modules.data.length > 0
        },

        async initPost() {
            let res = await initProject(this.company)
            this.projects.splice(0, 0, res)

            this.offset += 1
        },

        async initPatch(projectId: string) {
            let res = await initProject(this.company, projectId)
            const index = this.projects.findIndex((project) => project.id == projectId)
            this.projects.splice(index, 1, res)
        },

        async initClose(project: Record<string, any>) {
            await initProjectClose(project)
        },
    },

    watch: {
        company: {
            immediate: true,
            deep: true,
            handler() {
                this.initiateProjects()
            },
        },
        searchTerm: lodash.debounce(function (this) {
            this.initiateProjects()
        }, 600),
    },
})

export default AdminProjects
